import { cn } from "@/lib/utils";

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: "sm" | "md" | "lg" | "xl";
    variant?: "primary" | "secondary" | "white";
}

export const Spinner = ({ className, size = "md", variant = "primary", ...props }: SpinnerProps) => {
    const sizeClasses = {
        sm: "h-4 w-4 border-2",
        md: "h-8 w-8 border-3",
        lg: "h-12 w-12 border-4",
        xl: "h-16 w-16 border-4",
    };

    const variantClasses = {
        primary: "border-primary border-t-transparent",
        secondary: "border-secondary border-t-transparent",
        white: "border-white border-t-transparent",
    };

    return (
        <div
            className={cn(
                "animate-spin rounded-full",
                sizeClasses[size],
                variantClasses[variant],
                className
            )}
            {...props}
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
};
